










































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes } from "@/data/table";
import { ActionTypes } from "@/data/enums";
import { IGateway } from "@/models/gateways";
import { IProvisionProvider } from "@/models/provisioning";
import { LogoSize, LogoType } from "@/data/enums/logos";

@Component
export default class SelectBrandGateway extends Mixins(
  FilteringSortingTableStore
) {
  // Props

  @Prop({ default: null })
  public selectedId!: string | null;

  @Prop({ default: "SPC" })
  public declare id: string;

  @Prop({ default: true })
  public declare ignoreHistory: boolean;

  @Prop({ default: () => ({}) })
  public defaultFilters!: { [key: string]: string };

  // Data

  public isProcessing: any[] = [];
  public dataModule = DataModules.GATEWAYS;
  public defaults = {
    limit: 5
  };

  public filters: IFilter[] = [
    {
      key: "name",
      label: this.$t("_.name"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS
    },
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.date_added")
    }
  ];

  // Life-cycle methods

  public created() {
    if (!this.$userCan("list_brand_gateways")) return;
    this.getData();
  }

  // Override mixin method
  public getStoreParams(params: any): Promise<any> {
    const filters = this.$_.mapKeys(
      this.defaultFilters,
      (v, key) => `filter[${key}]`
    );
    return this.$_.merge(
      { params: { ...filters, with: "gateway_provider.logos" } },
      params
    );
  }

  public getProviderLogoUrl(provider: IProvisionProvider) {
    return this.$_.get(
      this.$_.find(provider.logos || [], logo => {
        if (logo.type === LogoType.ICON && logo.size === LogoSize.ONE_X)
          return true;
        return false;
      }),
      "url",
      null
    );
  }

  public async openGatewayModal(gateway: IGateway) {
    const response = await this.$store.dispatch(
      `data/${DataModules.GATEWAYS}/openManageGateway`,
      {
        gateway,
        gatewayProviderId: gateway.gateway_provider_id,
        actionType: ActionTypes.UPDATE
      }
    );
    if (response.gateway) this.getData({ ...this.config, ignoreStored: true });
  }

  public onSelect(id) {
    this.isProcessing.push(id);
    this.$emit("select", id);
  }
}
